import { useEffect, useState } from 'react';
import {
    Card,
    Container,
    styled,
    Tabs,
    Tab,
    Box
} from '@mui/material';
import { useSelector } from 'react-redux';

import { Iconify, Page } from '../../../components';
import { CustomerService } from '../../../services/customer.service';
import { ProfileCover } from '../../../components/profile-cover';
import { CustomerProfileData } from '../../../components/customer-profile-data';
import { RootState } from '../../../store';
import { useQuery } from '../../../hooks/useQuery';
import { CustomerChangePasswordForm } from '../../../components/customer-change-password-form';

const TabsWrapperStyle = styled('div')(({ theme }) => ({
    zIndex: 9,
    bottom: 0,
    width: '100%',
    display: 'flex',
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.up('sm')]: {
        justifyContent: 'center',
    },
    [theme.breakpoints.up('md')]: {
        justifyContent: 'flex-end',
        paddingRight: theme.spacing(3),
    },
}));

export const ProfileScreen = () => {
    const { authUser } = useSelector((state: RootState) => state.auth);
    const [currentTab, setCurrentTab] = useState('My Profile');

    const queryParams = useQuery();

    useEffect(() => {
        const controller = new AbortController();

        (async () => {
            if (authUser.pomMaster) {
                await CustomerService.getCustomerDetails(queryParams.get('customer')!, controller.signal);
            } else {
                await CustomerService.getCustomerDetails(undefined, controller.signal);
            }
        })();

        return () => controller.abort();
    }, []);
    
    const TABS = [
        {
            value: 'My Profile',
            content: <CustomerProfileData />,
            icon: <Iconify icon="ic:round-account-box" />,
        },
        {
            value: 'Change Password',
            content: <CustomerChangePasswordForm />,
            icon: <Iconify icon="ic:round-account-box" />,
        },
    ];

    return (
        <Page title={'POM Safe - My Profile'}>
            <Container maxWidth={'xl'}>
                <Card
                    sx={{
                        mb: 3,
                        height: 280,
                        position: 'relative',
                    }}
                >
                    <ProfileCover />
                    <TabsWrapperStyle>
                        <Tabs
                            value={currentTab}
                            scrollButtons="auto"
                            variant="scrollable"
                            allowScrollButtonsMobile
                            onChange={(e, value) => setCurrentTab(value)}
                        >
                            {TABS.map((tab) => (
                                <Tab style={{ fontSize: 13, fontWeight: 500 }} disableRipple key={tab.value} label={tab.value} icon={tab.icon} value={tab.value} />
                            ))}
                        </Tabs>
                    </TabsWrapperStyle>
                </Card>

                {TABS.map(
                    (tab) => tab.value === currentTab && <Box key={tab.value}> {tab.content} </Box>
                )}
                
            </Container>
        </Page>
    );
};
